import React, { useEffect } from 'react'
import { Modal, Button, Form } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy, faSpinner } from '@fortawesome/free-solid-svg-icons'
import {
  BsCheck,
  BsCheckCircleFill,
  BsEnvelope,
  BsEnvelopeAtFill,
  BsEnvelopeCheckFill,
  BsInfoCircle,
} from 'react-icons/bs'
import { useDispatch, useSelector } from 'react-redux'
import SafeFormatMessage from '../Shared/SafeFormatMessage/SafeFormatMessage'
import { Wrapper } from './GenerateSubscriptionCancelLinkModal.styled'
import useRequest from '../../../axios/apis/useRequest'
import { setLoading } from '../../../store/slices/main'

const GenerateSubscriptionCancelLinkModal = ({
  setVisible,
  subscriptionId,
  subscriberEmail,
}) => {
  const { subscriptionCancelationLink, subscriptionCancelationLinkWithEmail } =
    useRequest()
  const [cancelationLink, setCancelationLink] = React.useState(
    'http://localhost:3000/admin-panel/tenants/d6872d10-2682-464a-9c8f-2a7a2e482910'
  )
  const [isEmailSent, setIsEmailSent] = React.useState(false)
  const [isSendingEmail, setIsSendingEmail] = React.useState(false)
  const direction = useSelector((state) => state.main.direction)

  useEffect(() => {
    if (!subscriptionId) return
    ;(async () => {
      const request = await subscriptionCancelationLink({
        subscriptionId,
      })
      setCancelationLink(request.data.data.cancelationLink)
    })()
  }, [subscriptionId])

  const handleCopyToClipboard = () => {
    if (cancelationLink) {
      navigator.clipboard.writeText(cancelationLink)
    }
  }

  const handleSendingEmail = async () => {
    setIsSendingEmail(true)
    try {
      await subscriptionCancelationLinkWithEmail({
        subscriptionId,
      })
      setIsEmailSent(true)
    } catch (error) {
      console.error('Error sending email:', error)
    } finally {
      setIsSendingEmail(false)
    }
  }

  return (
    <Wrapper>
      {cancelationLink ? (
        <Form>
          <Modal.Header>
            <Modal.Title>
              <>
                <BsCheckCircleFill
                  style={{ color: 'green', marginLeft: '5px' }}
                />
                <span style={{ color: 'green', marginLeft: '5px' }}>
                  <SafeFormatMessage id="Cancelation-link-generated-successfully" />
                </span>
              </>
            </Modal.Title>
            <Button
              variant="close"
              aria-label="Close"
              onClick={() => setVisible(false)}
            />
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>
                <SafeFormatMessage id="Cancelation-Link" />
              </Form.Label>
              <div
                className={
                  direction === 'rtl'
                    ? 'input-group input-group-rtl'
                    : 'input-group'
                }
              >
                <input
                  type="text"
                  className="form-control"
                  value={cancelationLink}
                  readOnly
                />
                <span className="input-group-text">
                  <FontAwesomeIcon
                    icon={faCopy}
                    onClick={handleCopyToClipboard}
                    style={{ cursor: 'pointer' }}
                  />
                </span>
              </div>{' '}
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="">
                <SafeFormatMessage
                  id="Send-cancelation-link-to-subscriber-email"
                  values={{
                    email: (
                      <span
                        className="fw-bold"
                        style={{ color: 'var(--second-color)' }}
                      >
                        {subscriberEmail}
                      </span>
                    ),
                  }}
                />
              </Form.Label>
              <div className="d-flex justify-content-center w-100">
                {!isEmailSent ? (
                  <Button
                    variant="secondary"
                    onClick={handleSendingEmail}
                    disabled={isSendingEmail}
                    className="w-100"
                  >
                    {isSendingEmail ? (
                      <>
                        <BsEnvelope />
                        <SafeFormatMessage id="Sending-Email" />
                      </>
                    ) : (
                      <>
                        <BsEnvelopeAtFill className="mb-1" /> {'  '}
                        <SafeFormatMessage id="Send-Email" />
                      </>
                    )}
                  </Button>
                ) : (
                  <Button variant="secondary" disabled className="w-100">
                    <span style={{ color: 'green' }}>
                      <BsEnvelopeCheckFill className="mb-1" />
                    </span>
                    {'  '}
                    <SafeFormatMessage id="Email-Sent" />
                  </Button>
                )}
              </div>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setVisible(false)}>
              <SafeFormatMessage id="Close" />
            </Button>
          </Modal.Footer>
        </Form>
      ) : (
        <Form>
          <Modal.Header>
            <Modal.Title>
              <>
                <FontAwesomeIcon
                  icon={faSpinner}
                  spin
                  style={{ color: 'orange', marginRight: '10px' }}
                />
                <span style={{ color: 'orange', marginRight: '10px' }}>
                  <SafeFormatMessage id="Cancelation-link-in-progress" />
                </span>
              </>
            </Modal.Title>
            <Button
              variant="close"
              aria-label="Close"
              onClick={() => setVisible(false)}
            />
          </Modal.Header>
          <Modal.Body>
            <p>
              <SafeFormatMessage id="The-cancelation-link-is-being-generated-or-unavailable-please-await-or-try-again-later" />
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setVisible(false)}>
              <SafeFormatMessage id="Close" />
            </Button>
          </Modal.Footer>
        </Form>
      )}
    </Wrapper>
  )
}

export default GenerateSubscriptionCancelLinkModal
